import React, { useContext } from "react";

import { withErrorBoundary } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";

// import components
import { SkeletonAnnotated } from "lib/components";
import { PrivateContext } from "lib/context";

// storage helpers
import { storageHelper } from "lib/helpers";

// import features
import OperatorPaymentList from "./operator/features";
import { ProviderPaymentList } from "./provider/features";

const { userKey } = constant;
const { operator, provider } = userKey;

const LakePaymentList = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === operator) {
      return <OperatorPaymentList />;
    }
    if (role === provider) {
      return <ProviderPaymentList />;
    }
    return null;
  };

  const currentUserRole = storageHelper.get("userRole");
  const PaymentListComponent = getComponent(currentUserRole);
  return PaymentListComponent;
};

export default withErrorBoundary(LakePaymentList);
